var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1924 0H3.80761L0 3.80761V9.1924L3.80761 13H9.1924L13 9.1924V3.80761L9.1924 0ZM6.50009 11.2168C6.11353 11.2168 5.80036 10.9034 5.80036 10.5169C5.80036 10.1305 6.11353 9.81715 6.50009 9.81715C6.88665 9.81715 7.19981 10.1305 7.19981 10.5169C7.19981 10.9034 6.88665 11.2168 6.50009 11.2168ZM7.19981 8.3616C7.19981 8.74799 6.88665 9.06133 6.50009 9.06133C6.11353 9.06133 5.80036 8.74799 5.80036 8.36143V2.48312C5.80036 2.09656 6.1137 1.78322 6.50009 1.78322C6.88665 1.78322 7.19981 2.09656 7.19981 2.48312V8.3616Z",
    fill: "#007AA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueAlert);
export default __webpack_public_path__ + "static/media/blue-alert.f9f6e59b2054adfb4ccd00155719cfea.svg";
export { ForwardRef as ReactComponent };